import { Timeline } from "primereact/timeline";
import { InventoryOperation } from "../apis/armoryApi";

interface AssetHistoryPanelProps {
  inventoryOperations: InventoryOperation[];
}

interface InventoryActions {
  [key: number]: string;
}

const AssetHistoryPanel: React.FC<AssetHistoryPanelProps> = ({
  inventoryOperations,
}) => {
  const assetHistory = inventoryOperations
    .filter((operation) => operation.success)
    .reverse();
  console.log("Asset History:", assetHistory);

  return (
    <Timeline
      value={assetHistory}
      opposite={(item) =>
        `${item.action?.name ?? item.action?.id.toString()}${
          item.lessee?.name ? " to " + item.lessee.name : ""
        }`
      }
      content={(item) => (
        <>
          <span className="pr-1">{`by ${item.actor.name}${item.site?.name ? " at " + item.site.name : ""}`}</span>
          <br />
          <small className="text-color-secondary">{item.date.toLocaleString()}</small>
        </>
      )}
    />
  );
};

export default AssetHistoryPanel;
